export default __webpack_public_path__ + "static/media/ocaml.b0862234.svg";